import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GetExternalEquipmentState } from './get-external-equipment.types';

const getExternalEquipmentFeatureSelector = createFeatureSelector<GetExternalEquipmentState>('getExternalEquipment');

export const selectGetExternalEquipmentLoading = createSelector(
  getExternalEquipmentFeatureSelector,
  state => state.updating
);

export const selectGetExternalEquipmentLoaded = createSelector(
  getExternalEquipmentFeatureSelector,
  state => state.updated
);

export const selectGetExternalEquipment = createSelector(
  getExternalEquipmentFeatureSelector,
  state => state.data
);

export const selectGetExternalEquipmentError = createSelector(
  getExternalEquipmentFeatureSelector,
  state => state.error
);
